import { visibilityOnPagesDefaultSettings } from '@elfsight/widget-conditional-display';
import type { AccessibilitySettings } from './types';

export const defaultSettings: AccessibilitySettings = {
  // audit
  auditReports: [],

  // theme
  theme: {
    type: 'light',
    accentColor: 'rgb(0, 109, 255)',
    themeSettings: {
      launcherButtonColor: 'rgb(0, 109, 255)',
      background: {
        type: 'color',
        color: 'rgb(250, 250, 250)'
      },
      headerIconBackgroundColor: 'rgb(0, 109, 255)',
      headerIconColor: 'rgb(255, 255, 255)',
      headerTextColor: 'rgb(17, 17, 17)',
      headerButtonsColor: 'rgb(17, 17, 17)',
      settingsBackgroundColor: 'rgb(255, 255, 255)',
      settingsTextColor: 'rgb(17, 17, 17)',
      settingsAccentColor: 'rgb(0, 109, 255)'
    }
  },

  // settings
  showAccessibilityInfo: false,
  showAccessibilityScore: false,
  position: {
    position: 'left',
    verticalOffset: 16,
    horizontalOffset: 16
  },
  visibilityOnDevices: 'allDevices',
  language: undefined,
  rememberVisitor: undefined,

  customCSS: '',
  customJS: '',

  ...visibilityOnPagesDefaultSettings
};
